<template>
  <b-container fluid v-if="($mq === 'mobile' || $mq === 'tablet')" style="background-color:#FAFAFA;min-height:100vh;">
    <!-- header -->
    <HeaderBackMobile :backToHome="false" leftAction="back"/>
    <main>
      <b-row>
        <b-col style="
          margin-top:20px;
          font-size: 15px;
          color: #121C2A;
          font-weight:500;
          ">
          Selecione o Endereço de Entrega.
        </b-col>
      </b-row>
      <b-row style="margin-top:18px;">
        <b-col style="
        height:2px;
        border: 1px solid #EFEFF1;
        "></b-col>
      </b-row>
      <AddressList @selectedAddress="(addressId) => selectAddress(addressId)" />
      
    </main>
    <footer style="position:relative;">
      <!-- fixed button action -->
      <b-row style="position:fixed;bottom:0px;width:100%;height:140px;background-color:#FAFAFA">
        <div
        @click="newAddress()"
        :style="{color: getCssColor('primary_bt')}"
        style="
          margin:10px auto 0 auto;
          width:calc( 100% - 64px);height:48px;
          line-height:48px;
          border-radius:4px;
          text-align:center;
          font-style: normal;
          font-weight: 600;
          font-size: 15px;
          text-transform: uppercase;
          ">CADASTRAR NOVO ENDEREÇO</div>
        <div
        @click="finishCheckout()"
        :style="{backgroundColor: getCssColor('primary_bt')}"
        style="
          margin:10px auto;
          width:calc( 100% - 64px);height:48px;
          line-height:48px;
          border-radius:4px;
          text-align:center;
          font-style: normal;
          font-weight: 600;
          font-size: 15px;
          text-transform: uppercase;
          color: #FFFFFF;">CONTINUAR</div>
      </b-row>
    </footer>
  </b-container>
</template>

<script>
import MembershipConn from '@/connection/membership'
import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
import AddressList from '@/components/AddressList.vue'
import colors from '@/mixins/colors'
import formaters from '@/mixins/formaters'
import { EventBus } from '@/behaviours/event-bus'

export default {
  data () {
    return {
      selectedId: 0
    }
  },

  mixins: [colors, formaters],
  components: {HeaderBackMobile, AddressList},

  

  methods: {
    async finishCheckout () {
      this.$store.state.showLoading = true
      this.$store.state.cartPrize.delivery_address_id = this.selectedId
      let result = await MembershipConn.checkoutOrder()
      console.log(result)
      this.$store.state.showLoading = false
      if (!result.error){
        this.$store.state.cartPrizeReturnData = result.data
        this.$store.state.cartPrize = {
          cart_prize_list: [],
          delivery_address_id: 0
        }
        this.$router.push({path: '/membership_success'})
      } else {
        EventBus.$emit('showAlert', 'error', result.msg)
      }
    },

    newAddress () {
      this.$store.state.newAddressOrigin = "membership"
      this.$router.push({path:'/address'})
    },

    selectAddress (addrId) {
      console.log('Endereco', addrId)
      this.selectedId = addrId
    }

    
  }
}
</script>

<style>

</style>
